import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const ShortenText = ({ text,length }) => {
  const shortenedText = text.length > length ? text.substring(0, length) + '...' : text;

  return (
    <Tooltip title={text} arrow>
        {shortenedText}
    </Tooltip>
  );
};

export default ShortenText;
